<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col">Employee Payslip</div>
            <!-- <div class="col text-end">
                 
                <label class="small-light-label heading">Month :</label>
                <select aria-label="monthyear" class="spacing-label" style="width: 35%;" placeholder="Month"
                    title="MonthName" name="Monthname" [(ngModel)]="selectedMonthYear"
                    (ngModelChange)="onMonthYearChange()" required>
                    <option *ngFor="let item of PaySlipData" [value]="item.MonthName + ' ' + item.YearName">
                        {{ item.MonthName }} - {{ item.YearName }}
                    </option>
                </select>
                <button type="button" name="Search" class="btn btn-sm btn-primary spacing-label" [disabled]="isDisabled"
                    (click)="EmpPayslip()">
                    <i class="bi bi-search" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Search':'Loading...'}}
                </button>
                
            </div> -->
        </div>
    </div>
    <div class="card-body" style="overflow: auto;">
        <div class="card-body p-1" style="overflow: auto; height: 450px;">
            <div class="row">
                <div class="col-md-6">
                    <!-- <label class="small-light-label heading">Employee :</label> -->
                    <!-- <label class="text-label  spacing-label">{{InputData.EmpName}} </label> -->
                    <label class="Label1 spacing-label">
                        <!-- {{InputData.EmpName}}({{InputData.EmpCode}}) -->
                        <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                            <div class="col-2">
                                <img *ngIf="InputData.Photo != null && InputData.Photo!= ''" mat-card-image
                                    class="userImage" [src]="common.PhotoLink(InputData.Photo)" />
                                <div *ngIf="InputData.Photo == null || InputData.Photo == ''" class="initial-image">
                                    <div class="image">
                                        {{common.getInitial(InputData.EmpName)}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-9 userdetail">
                                <span class="text-label">{{InputData.EmpName}}</span><br />
                                <span class="text-label-light">#{{InputData.EmpCode}}</span><br />
                                <span class="text-label-light">{{InputData.DesignationName}}</span>
                            </div>
                        </div>
                    </label>
                </div>

            </div>

            <!-- <div class="row"> -->
            <!-- <div class="col-md-3">
                    <button type="button" name="Search" class="btn btn-sm btn-primary" [disabled]="isDisabled">
                        <i class="bi bi-search" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Search':'Loading...'}}
                    </button>
                </div> -->
            <!-- </div> -->
            <div class="container">
                <!-- <div class="ms-4"> -->
                <div class="row">
                    <div class="col-md-4">
                        <label class="form-label text-label-light">Site :</label>
                        <label class="text-label  spacing-label">{{InputData.SiteName}} </label>
                    </div>
                    <div class="col-md-4">
                        <label class="small-light-label heading">Branch Name :</label>
                        <label class="text-label  spacing-label">{{InputData.BranchName}} </label>
                    </div>
                    <div class="col-md-4">
                        <label class="small-light-label heading">Client Name :</label>
                        <label class="text-label  spacing-label">{{InputData.ClientGroupName}} </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <label class="form-label text-label-light">Month Days :</label>
                        <label class="form-label text-label-dark  spacing-label">{{this.Detail.Month}} </label>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label text-label-light">Weekly Offs :</label>
                        <label class="text-label  spacing-dark">{{this.Detail.Holiday}} </label>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label text-label-light">Paid Leave :</label>
                        <label class="text-label  spacing-dark">{{this.Detail.PaidHolidays}} </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <label class="form-label text-label-light">Payable Days :</label>
                        <label class="form-label text-label-dark  spacing-label">{{this.Detail.Payable}} </label>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label text-label-light">Normal Days :</label>
                        <label class="form-label text-label-dark  spacing-label">{{this.InputData.NormalDays}}
                        </label>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label text-label-light">ED :</label>
                        <label class="form-label text-label-dark  spacing-label">{{this.Detail.OTHrs}} </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <label class="form-label text-label-light">WO:</label>
                        <label class="text-label  spacing-dark">{{this.Detail.WO}} </label>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label text-label-light">ESIC No:</label>
                        <label class="text-label  spacing-dark">{{this.Detail.ESICNo}} </label>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label text-label-light">PF No. :</label>
                        <label class="text-label  spacing-dark">{{this.Detail.PFNo}} </label>
                    </div>

                </div>
                <div class="row">
                    <div class="col-md-4">
                        <label class="form-label text-label-light">Date Of Joining :</label>
                        <label class="form-label text-label-dark  spacing-label">{{this.Detail.JoiningDate}}
                        </label>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label text-label-light">PAN No. : </label>
                        <label class="text-label  spacing-dark">{{this.Detail.PanNumber}} </label>
                    </div>
                    <div class="col-md-4">
                        <label class="form-label text-label-light">UAN No:</label>
                        <label class="text-label  spacing-dark">{{this.Detail.UANNo}} </label>
                    </div>
                </div>
                <!-- </div> -->
            </div>
            <div class="container2">
                PAYSLIP FOR {{selectedMonthYear}} - ({{this.Detail.FirstDate}} - {{this.Detail.LastDate}})
            </div>
            <div class="row m-1">
                <div class="col-md-6 px-1">
                    <div class="card" style="border-radius: 0%;">
                        <div class="card-header" style="text-align: center;font-weight: 600; color: green;">
                            Earnings
                        </div>
                        <div class="card-body" style="overflow: auto; height: 270px;">
                            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                                class="customeDatatable table table-bordered">
                                <thead class="table-light">
                                    <tr>
                                        <th style="width: 100%;">Salary Head</th>
                                        <th style="width: 5%;">Payable</th>
                                        <th style="width: 5%;">Earned</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let site of EmpPaySlip; let i = index">
                                        <td>{{ site['SalaryHeadName'] }}
                                            {{ site['SalaryHeadName'] ? '(' + site['SalaryHeadCode'] + ')' : '' }}
                                        </td>
                                        <td style="width: 5%;">{{ site['ActualValue'] === 0 ? '' : site['ActualValue']
                                            }}
                                        </td>
                                        <td style="width: 5%;">{{ site['Value'] === 0 ? '' : site['Value'] }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 px-1">
                    <div class="card" style="border-radius: 0%;">
                        <div class="card-header" style="text-align: center;font-weight: 600; color: red;">
                            Deductions
                        </div>
                        <div class="card-body" style="overflow: auto;height: 270px;">
                            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                                class="customeDatatable table table-bordered">
                                <thead class="table-light">
                                    <tr>
                                        <!-- <th scope="col">#</th> -->
                                        <th style="width: 100%;">Salary Head</th>
                                        <th style="width: 5%;">Payable</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let site of EmpPaySlip; let i = index">
                                        <!-- <th scope="row">{{ i + 1 }}</th> -->
                                        <td>{{ site['DED_SalaryHeadName'] }}
                                            {{ site['DED_SalaryHeadName'] ? '(' + site['DED_SalaryHeadCode'] + ')' : ''
                                            }}
                                        </td>
                                        <td style="width: 5%;">{{ site['DED_Value'] === 0 ? '' : site['DED_Value']}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="container3">
                <div class="row">
                    <div class="col-md-6">
                        <div class="row" style="color: rgb(1, 95, 1);">
                            <div class="col-md-8 text-end">
                                <label class="form-label spacing-dark" style="font-size: 14px;">Total Earnings : </label>
                            </div>
                            <div class="col-md-2 text-end">
                                <label class="text-label spacing-dark text-label-dark ">{{totalPayable}} </label>
                            </div>
                            <div class="col-md-2 text-right">
                                <label class="text-label  spacing-dark text-label-dark ">{{totalEarned}} </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        
                        <div class="row" style="color: rgb(190, 2, 2);">
                            <div class="col-md-10 text-end">
                                <label class="form-label spacing-dark" style="font-size: 14px;">Total Deductions : </label>
                            </div>
                           
                            <div class="col-md-2 text-right">
                                <label class="text-label  spacing-dark text-label-dark ">{{totalDedPayable}} </label>
                            </div>
                        </div>
                        <div class="row" style="color: rgb(1, 95, 1);">
                            <div class="col-md-9 text-end">
                                <label class="form-label spacing-dark" style="font-size: 14px;">NET PAYABLE : </label>
                            </div>
                            <div class="col-md-3 text-right">
                                <label class="text-label  spacing-dark text-label-dark ">{{NetPayable}} </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="container3">
                <div class="row">
                    <div class="col-md-6 col-sm-12">
                        <div class="row" style="color: rgb(1, 95, 1);">
                            <div class="col-md-8 col-8 text-end" style="overflow: auto;">
                                <label class="form-label spacing-dark" style="font-size: 14px;">Total Earnings :
                                </label>
                            </div>
                            <div class="col-md-2 col-2 text-end" style="overflow: auto;">
                                <label class="text-label spacing-dark text-label-dark ">{{totalPayable}} </label>
                            </div>
                            <div class="col-md-2 col-2 text-end" style="overflow: auto;">
                                <label class="text-label spacing-dark text-label-dark ">{{totalEarned}} </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="row" style="color: rgb(190, 2, 2);">
                            <div class="col-md-10 col-9 text-end" style="overflow: auto;">
                                <label class="form-label spacing-dark" style="font-size: 14px;">Total Deductions :
                                </label>
                            </div>
                            <div class="col-md-2 col-3 text-end" style="overflow: auto;">
                                <label class="text-label spacing-dark text-label-dark">{{totalDedPayable}}</label>
                            </div>
                        </div>
                        <div class="row" style="color: rgb(1, 95, 1);">
                            <div class="col-md-9 col-9 text-end" style="overflow: auto;">
                                <label class="form-label spacing-dark" style="font-size: 14px;">NET PAYABLE : </label>
                            </div>
                            <div class="col-md-3 col-3 text-end" style="overflow: auto;">
                                <label class="text-label spacing-dark text-label-dark ">{{NetPayable}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container4">
                <div class="row" style="overflow: auto;">
                    <div class="col-md-8" style="overflow: auto;">
                        <label class="form-label spacing-dark">Total Earnings : </label>
                        <label class="text-label  spacing-dark spacing-label">{{NetPayableInWords}} </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled" (click)="Cancel()"
                    autofocus="true" #cancelButton id="cancelButton">
                    <i class="bi bi-x-lg" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>